import { website } from '@/axios'

export default {
  getAllNotifications () {
    return website().get('/user/notifications')
  }
}
